<template>
  <div class="right">
    <div class="title-body">
      <div class="title-body-title">
        <div>客户服务及消费者投诉方式</div>
        <div
          style="
            flex: 1;
            height: 4px;
            margin-top: 18px;
            margin-left: 10px;
            background-image: url(./static/img/bar.png);
          "
        ></div>
      </div>
    </div>
    <div class="infomation">
      <!--内容开始-->
      <div class="complaint">
        <div
          style="
            width: calc(100% - 40px);
            padding: 25px 20px;
            line-height: 30px;
            background-color: rgb(248, 248, 248);
            margin-bottom: 20px;
            display: flex;
            position: relative;
          "
        >
          <span style="font-size: 14px; margin-right: 20px"
            >理赔、保全等客户服务电话</span
          >
          <h3>400-820-3351</h3>
          <div
            class="el-button-scope"
            style="position: absolute; right: 20px"
          ></div>
        </div>
        <div class="complaint-img"><!--客服图片--></div>
        <div class="complaintDialog">
          <div class="el-dialog__wrapper" style="display: none">
            <div
              role="dialog"
              aria-modal="true"
              aria-label="在线投诉"
              class="el-dialog el-dialog--center"
              style="margin-top: 15vh"
            >
              <div class="el-dialog__header">
                <span class="el-dialog__title">在线投诉</span
                ><!---->
              </div>
              <!----><!---->
            </div>
          </div>
        </div>
      </div>
      <!--内容结束-->
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerServiceAndConsumer",
  components: {},
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped lang="less">
@import "./../assets/table";
</style>



// WEBPACK FOOTER //
// src/pages/customerServiceAndConsumer.vue